export enum ArrowDirectionEnum {
  UP = "up",
  DOWN = "down",
  OPEN = "open",
  CLOSE = "close",
}
